import { z } from 'zod';

export const $CandidateProfile = z.object({
  id: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  phone: z.string(),
  position: z.string(),
});
